import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useTranslation } from "@i18n";
import SAR from "@componentsShared/SAR/SAR";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FlowButton from "@/pages/sell-my-car/components/FlowButton";
import FLowFixedContainer from "@/pages/sell-my-car/components/FLowFixedContainer";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import { getStep, submitSellTradeStep } from "@/apis/sell-my-car";
import useHelpers from "@hooks/useHelpers";
import { formatNumberWithCommas } from "@/utils/stringHelpers";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
var EstimatedPriceScreen = function EstimatedPriceScreen() {
  var _state$draftOrder, _state$draftOrder3, _state$draftOrder4, _state$draftOrder4$cu, _state$draftOrder4$cu2, _state$draftOrder5, _state$draftOrder5$cu, _state$draftOrder5$cu2, _state$draftOrder6, _state$draftOrder6$cu, _state$draftOrder6$cu2;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    dataActions = _useSellCarData.actions;
  var _useScreenNavigation = useScreenNavigation(),
    actions = _useScreenNavigation.actions;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var navigate = useNavigate();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useState = useState(false),
    submissionLoading = _useState[0],
    setSubmissionLoading = _useState[1];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var requestId = searchParams.get("request_id") || (state === null || state === void 0 ? void 0 : (_state$draftOrder = state.draftOrder) === null || _state$draftOrder === void 0 ? void 0 : _state$draftOrder.requestId);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _state$draftOrder2, _state$draftOrder2$cu;
      var stepData, res, _stepResponse$data, _stepData$current_ste, landingPageParam, getStepParams, stepResponse, _stepData, currentStepKey, urlParams, newURL, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (requestId) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            stepData = state === null || state === void 0 ? void 0 : (_state$draftOrder2 = state.draftOrder) === null || _state$draftOrder2 === void 0 ? void 0 : (_state$draftOrder2$cu = _state$draftOrder2.currentStep) === null || _state$draftOrder2$cu === void 0 ? void 0 : _state$draftOrder2$cu.data;
            trackEvents("price_approval_click", {
              request_id: requestId,
              car_year: (stepData === null || stepData === void 0 ? void 0 : stepData.year) || "",
              car_odometer_range: (stepData === null || stepData === void 0 ? void 0 : stepData.odometer) || "",
              car_city: (stepData === null || stepData === void 0 ? void 0 : stepData.city_name) || "",
              inspection_city: (stepData === null || stepData === void 0 ? void 0 : stepData.city_name) || "",
              min_proposed_price: (stepData === null || stepData === void 0 ? void 0 : stepData.minimum_offer_price) || "",
              max_proposed_price: (stepData === null || stepData === void 0 ? void 0 : stepData.maximum_offer_price) || "",
              platform: getPlatformInfo(),
              version: "3"
            });
            setSubmissionLoading(true);
            _context.p = 2;
            _context.n = 3;
            return submitSellTradeStep({
              request_id: requestId
            });
          case 3:
            res = _context.v;
            if (!(res !== null && res !== void 0 && res.data)) {
              _context.n = 5;
              break;
            }
            landingPageParam = searchParams.get("landing_page");
            getStepParams = {
              request_id: requestId
            };
            if (landingPageParam === "true") {
              getStepParams.landing_page = true;
            }
            _context.n = 4;
            return getStep(getStepParams);
          case 4:
            stepResponse = _context.v;
            _stepData = stepResponse === null || stepResponse === void 0 ? void 0 : (_stepResponse$data = stepResponse.data) === null || _stepResponse$data === void 0 ? void 0 : _stepResponse$data.data;
            if (_stepData) {
              dataActions.setStepNavigation(_stepData.previous_step || null, _stepData.current_step || null);
            }
            currentStepKey = _stepData === null || _stepData === void 0 ? void 0 : (_stepData$current_ste = _stepData.current_step) === null || _stepData$current_ste === void 0 ? void 0 : _stepData$current_ste.step_key;
            if (currentStepKey) {
              urlParams = {
                request_id: requestId
              };
              if (landingPageParam === "true") {
                urlParams.landing_page = "true";
              }
              newURL = createUrl("/site/sell-my-car", urlParams);
              window.history.replaceState({}, "", newURL);
              actions.navigateToScreen(currentStepKey);
              navigate(newURL, {
                replace: true
              });
            }
          case 5:
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            console.error("Submit error:", _t);
          case 7:
            _context.p = 7;
            setSubmissionLoading(false);
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 6, 7, 8]]);
    }));
    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  // Show loader while fetching step data
  if (state !== null && state !== void 0 && (_state$draftOrder3 = state.draftOrder) !== null && _state$draftOrder3 !== void 0 && _state$draftOrder3.isLoadingStepData) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4 flex items-center justify-center h-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "animate-pulse flex flex-col gap-4 w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-14 bg-gray-300 rounded-lg w-full"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-48 bg-gray-300 rounded-lg w-full"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-12 bg-gray-300 rounded-lg w-full"
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-estimated-price-screen",
    className: "p-4 flex flex-col gap-4 md:p-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 md:max-w-[666px] mx-auto w-full"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-estimated-price-car-info",
    className: "rounded-lg border border-solid border-gray-echo px-3 py-2.5 min-h-14"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-estimated-price-car-name",
    className: "font-bold text-xl text-black-primary md:font-normal md:text-center"
  }, state === null || state === void 0 ? void 0 : (_state$draftOrder4 = state.draftOrder) === null || _state$draftOrder4 === void 0 ? void 0 : (_state$draftOrder4$cu = _state$draftOrder4.currentStep) === null || _state$draftOrder4$cu === void 0 ? void 0 : (_state$draftOrder4$cu2 = _state$draftOrder4$cu.data) === null || _state$draftOrder4$cu2 === void 0 ? void 0 : _state$draftOrder4$cu2.car_name)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-estimated-price-box",
    className: "flex flex-col gap-6 items-center rounded-lg border border-solid border-gray-echo p-6"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-estimated-price-title",
    className: "text-black-primary text-base font-bold"
  }, tShort("sell_trade_v2/estimated_price_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-estimated-price-range",
    className: "flex gap-3 items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-estimated-price-min",
    className: "text-success font-bold text-3xl"
  }, formatNumberWithCommas(Math.round(state === null || state === void 0 ? void 0 : (_state$draftOrder5 = state.draftOrder) === null || _state$draftOrder5 === void 0 ? void 0 : (_state$draftOrder5$cu = _state$draftOrder5.currentStep) === null || _state$draftOrder5$cu === void 0 ? void 0 : (_state$draftOrder5$cu2 = _state$draftOrder5$cu.data) === null || _state$draftOrder5$cu2 === void 0 ? void 0 : _state$draftOrder5$cu2.minimum_offer_price))), /*#__PURE__*/React.createElement("div", {
    className: "text-success font-bold text-3xl"
  }, "-"), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-estimated-price-max",
    className: "text-success font-bold text-3xl"
  }, formatNumberWithCommas(Math.round(state === null || state === void 0 ? void 0 : (_state$draftOrder6 = state.draftOrder) === null || _state$draftOrder6 === void 0 ? void 0 : (_state$draftOrder6$cu = _state$draftOrder6.currentStep) === null || _state$draftOrder6$cu === void 0 ? void 0 : (_state$draftOrder6$cu2 = _state$draftOrder6$cu.data) === null || _state$draftOrder6$cu2 === void 0 ? void 0 : _state$draftOrder6$cu2.maximum_offer_price)))), /*#__PURE__*/React.createElement(SAR, {
    className: "text-success text-3xl"
  }))), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-estimated-price-note",
    className: "flex items-center gap-1 justify-center"
  }, /*#__PURE__*/React.createElement("span", {
    id: "sell-car-estimated-price-note-highlight",
    className: "text-xs font-bold text-black-primary"
  }, tShort("sell_trade_v2/estimated_price_note_highlight", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("span", {
    id: "sell-car-estimated-price-note-text",
    className: "text-xs font-regular text-black-primary"
  }, tShort("sell_trade_v2/estimated_price_note_text", {
    ns: "web_sell_trade"
  }))))), /*#__PURE__*/React.createElement(FLowFixedContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "md:max-w-[360px] md:mx-auto md:mt-24"
  }, /*#__PURE__*/React.createElement(FlowButton, {
    id: "sell-car-estimated-price-submit-btn",
    type: "button",
    disabled: submissionLoading || !requestId,
    onClick: handleSubmit,
    className: "md:w-[360px] w-full"
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: submissionLoading
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null)), /*#__PURE__*/React.createElement(Else, null, tShort("sell_trade_v2/submit", {
    ns: "web_sell_trade"
  })))))));
};
export default EstimatedPriceScreen;